import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { MultiVariantIllustration } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/components/MultiVariantIllustration";
import { OrderImportIllustration } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/components/OrderImportIllustration";
import { ProductDetailsIllustration } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/components/ProductDetailsIllustration";
import { Section } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/components/Section";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { Spacer, getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React, { useEffect, useRef, useState } from "react";
import styled, { css } from "styled-components";
export var ANIMATION_INTERVAL_MS = 5000;
var TRANSITION_DURATION_MS = 500;
export var FlexibleSettingsSection = function() {
    var _useViewport = useViewport(), isMobile = _useViewport.isMobile, isTablet = _useViewport.isTablet;
    var _useState = _sliced_to_array(useState(0), 2), currentSubsection = _useState[0], setCurrentSubsection = _useState[1];
    var intervalId = useRef(undefined);
    useEffect(function() {
        if (isMobile) {
            return;
        }
        intervalId.current = setInterval(function() {
            setCurrentSubsection(function(prevSubsection) {
                return (prevSubsection + 1) % SUBSECTIONS.length;
            });
        }, ANIMATION_INTERVAL_MS);
        return function() {
            if (intervalId.current) {
                clearInterval(intervalId.current);
            }
        };
    }, [
        isMobile
    ]);
    var handleSubsectionClick = function(index) {
        // Stop the animation when a subsection is clicked
        if (intervalId.current) {
            clearInterval(intervalId.current);
        }
        setCurrentSubsection(index);
    };
    if (isMobile) {
        return /*#__PURE__*/ _jsxs(Section, {
            color: Core.surface.inverse,
            children: [
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "7x"
                }),
                /*#__PURE__*/ _jsx(SectionHeader, {}),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "3x"
                }),
                /*#__PURE__*/ _jsx(Column, {
                    gap: "8x",
                    children: SUBSECTIONS.map(function(param, index) {
                        var heading = param.heading, body = param.body, Illustration = param.illustration;
                        return /*#__PURE__*/ _jsxs(Column, {
                            children: [
                                /*#__PURE__*/ _jsx(Subsection, {
                                    heading: heading,
                                    body: body
                                }),
                                /*#__PURE__*/ _jsx(Spacer, {
                                    height: "3x"
                                }),
                                /*#__PURE__*/ _jsx(Illustration, {
                                    visible: true
                                })
                            ]
                        }, index);
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "7x"
                })
            ]
        });
    }
    if (isTablet) {
        return /*#__PURE__*/ _jsxs(Section, {
            color: Core.surface.inverse,
            children: [
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "10x"
                }),
                /*#__PURE__*/ _jsx(SectionHeader, {
                    center: true
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "5x"
                }),
                /*#__PURE__*/ _jsx(Column, {
                    gap: "8x",
                    children: SUBSECTIONS.map(function(param, index) {
                        var heading = param.heading, body = param.body, Illustration = param.illustration;
                        return /*#__PURE__*/ _jsx(Row, {
                            justify: "space-between",
                            children: index % 2 === 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(SectionTextWrapper, {
                                        justify: "center",
                                        children: /*#__PURE__*/ _jsx(Subsection, {
                                            heading: heading,
                                            body: body
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(IllustrationWrapper, {
                                        children: /*#__PURE__*/ _jsx(Illustration, {
                                            visible: true
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(IllustrationWrapper, {
                                        children: /*#__PURE__*/ _jsx(Illustration, {
                                            visible: true
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(SectionTextWrapper, {
                                        justify: "center",
                                        children: /*#__PURE__*/ _jsx(Subsection, {
                                            heading: heading,
                                            body: body
                                        })
                                    })
                                ]
                            })
                        }, index);
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "10x"
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs(Section, {
        color: Core.surface.inverse,
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                height: 120
            }),
            /*#__PURE__*/ _jsxs(Row, {
                justify: "space-between",
                children: [
                    /*#__PURE__*/ _jsxs(SectionTextWrapper, {
                        children: [
                            /*#__PURE__*/ _jsx(SectionHeader, {}),
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: "5x"
                            }),
                            /*#__PURE__*/ _jsx(Column, {
                                gap: "4x",
                                children: SUBSECTIONS.map(function(subsection, index) {
                                    return /*#__PURE__*/ _jsxs(SubsectionContainer, {
                                        onClick: function() {
                                            return handleSubsectionClick(index);
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx(SubsectionBar, {
                                                $selected: index === currentSubsection
                                            }),
                                            /*#__PURE__*/ _jsx(Spacer, {
                                                width: "3x"
                                            }),
                                            /*#__PURE__*/ _jsx(Subsection, {
                                                heading: subsection.heading,
                                                body: subsection.body,
                                                selected: index === currentSubsection
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(IllustrationWrapper, {
                        children: SUBSECTIONS.map(function(param, index) {
                            var Illustration = param.illustration;
                            return(// Hide illustrations except current one so that images aren't refetched on every animation interval
                            /*#__PURE__*/ _jsx(IllustrationContainer, {
                                $selected: index === currentSubsection,
                                children: /*#__PURE__*/ _jsx(Illustration, {
                                    visible: index === currentSubsection
                                })
                            }, index));
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: 120
            })
        ]
    });
};
var SectionHeader = function(param) {
    var center = param.center;
    return /*#__PURE__*/ _jsx(Typography, {
        align: center ? "center" : "left",
        variant: {
            mobileAndAbove: "displaySSerifRegular",
            tabletAndAbove: "displayMSerifRegular"
        },
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "aLPGv0",
            defaultMessage: [
                {
                    type: 0,
                    value: "Flexible settings, for every workflow"
                }
            ]
        })
    });
};
var Subsection = function(param) {
    var heading = param.heading, body = param.body, selected = param.selected;
    var _useViewport = useViewport(), isMobile = _useViewport.isMobile, isTablet = _useViewport.isTablet;
    if (isMobile) {
        return /*#__PURE__*/ _jsxs(Column, {
            gap: "1x",
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "subheadingSansMedium",
                    children: heading
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraphSansRegular",
                    children: body
                })
            ]
        });
    }
    if (isTablet) {
        return /*#__PURE__*/ _jsxs(Column, {
            gap: "2x",
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "sectionHeaderSansMedium",
                    children: heading
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "subheadingSansRegular",
                    children: body
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs(Column, {
        gap: "1x",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "sectionHeaderSansMedium",
                color: selected ? Core.text.default : Core.text.subdued,
                children: heading
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "subheadingSansRegular",
                color: selected ? Core.text.default : Core.text.subdued,
                children: body
            })
        ]
    });
};
var SUBSECTIONS = [
    {
        heading: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "HIUcX0",
            defaultMessage: [
                {
                    type: 0,
                    value: "Customize how you import your orders"
                }
            ]
        }),
        body: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "aLbgrJ",
            defaultMessage: [
                {
                    type: 0,
                    value: "Automatically import orders to your POS upon purchase, or review products first before importing them."
                }
            ]
        }),
        illustration: OrderImportIllustration
    },
    {
        heading: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "SezlUg",
            defaultMessage: [
                {
                    type: 0,
                    value: "Edit product details before or after you sync"
                }
            ]
        }),
        body: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "wi54pH",
            defaultMessage: [
                {
                    type: 0,
                    value: "Use our bulk editor to edit details such as product name, retail price, and category before importing them to your POS. Or import the information as-is, and make edits later."
                }
            ]
        }),
        illustration: ProductDetailsIllustration
    },
    {
        heading: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "vB4vbE",
            defaultMessage: [
                {
                    type: 0,
                    value: "Group or split multi-variant products"
                }
            ]
        }),
        body: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "IV3fFw",
            defaultMessage: [
                {
                    type: 0,
                    value: "Organize multi-variant products in the way you want. Split them into separate listings or group them into a single one."
                }
            ]
        }),
        illustration: MultiVariantIllustration
    }
];
var SectionTextWrapper = styled(Column).withConfig({
    componentId: "sc-57ef402d-0"
})([
    "width:calc(50% - ",
    ");max-width:504px;",
    "{width:calc(50% - ",
    ");}"
], getSpacing("10x"), responsiveMediaQueries.tabletAndBelow, getSpacing("5x"));
var SubsectionContainer = styled(Row).withConfig({
    componentId: "sc-57ef402d-1"
})([
    "cursor:pointer;user-select:none;"
]);
var SubsectionBar = styled.div.withConfig({
    componentId: "sc-57ef402d-2"
})([
    "height:100%;width:",
    ";background-color:",
    ";flex-shrink:0;"
], getSpacing("1x"), function(props) {
    return props.$selected ? Core.border.default : Core.border.muted;
});
var IllustrationContainer = styled.div.withConfig({
    componentId: "sc-57ef402d-3"
})([
    "position:absolute;width:100%;visibility:",
    ";opacity:",
    ";transition:",
    ";"
], function(props) {
    return props.$selected ? "visible" : "hidden";
}, function(props) {
    return props.$selected ? 1 : 0.65;
}, function(props) {
    return props.$selected ? css([
        "opacity ",
        "ms ease"
    ], TRANSITION_DURATION_MS) : "none";
});
var IllustrationWrapper = styled.div.withConfig({
    componentId: "sc-57ef402d-4"
})([
    "position:relative;width:50%;max-width:584px;"
]);
